import React from "react";
import { Modal } from "@mantine/core";

import ModalHeader from "components/ModalHeader";
import AddUserForm from "./adduserForm";

type AddClientModalProps = {
  opened: boolean;
  onClose: () => void;
};

function AdduserModal({ opened, onClose }: AddClientModalProps) {
  return (
    <Modal
      opened={opened}
      onClose={onClose}
      overlayOpacity={0.5}
      shadow="xs"
      size="lg"
      withCloseButton={false}
      transitionDuration={300}
      centered
    >
      <ModalHeader
        title="Add User"
        onClose={onClose}
        ariaLabel="Close add Holiday modal"
      />
      <AddUserForm onClose={onClose} />
    </Modal>
  );
}

export default AdduserModal;
